import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/95 shadow-lg' : 'bg-black/95 shadow-lg'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollTo('hero')}>
          <img
            src="https://public.readdy.ai/ai/img_res/2af6d988-63de-4022-9613-4edcf52fc5d0.png"
            alt="Logo"
            className="h-10 w-auto object-contain"
          />
        </div>
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Home', id: 'hero' },
            { label: 'Features', id: 'sistemas' },
            { label: 'Pricing', id: 'bonos' },
            { label: 'FAQ', id: 'faq' },
            { label: 'Contact', id: 'contact' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-gray-400 hover:text-white transition-colors text-sm font-medium capitalize cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('bonos')}
            className="bg-[#00FF88] text-black font-bold text-sm px-5 py-2 rounded-full hover:bg-[#00e07a] transition-all cursor-pointer whitespace-nowrap"
          >
            Acceso Inmediato
          </button>
        </div>
        <button
          className="md:hidden flex items-center justify-center w-9 h-9 text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>
      {menuOpen && (
        <div className="md:hidden bg-black/98 border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'Home', id: 'hero' },
            { label: 'Features', id: 'sistemas' },
            { label: 'Pricing', id: 'bonos' },
            { label: 'FAQ', id: 'faq' },
            { label: 'Contact', id: 'contact' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-gray-400 hover:text-white transition-colors text-sm font-medium text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('bonos')}
            className="bg-[#00FF88] text-black font-bold text-sm px-5 py-2 rounded-full hover:bg-[#00e07a] transition-all cursor-pointer whitespace-nowrap w-fit"
          >
            Acceso Inmediato
          </button>
        </div>
      )}
    </nav>
  );
}
